<template>
	<div class="diagram-step-wrapper" :style="cssVariables">
		<div class="diagram-icon flex-initial">
			<div class="diagram-icon-wrapper">
				<font-awesome-icon :icon="['fas', 'bullseye']"/>
			</div>
			<div class="diagram-line"></div>
		</div>
		<div class="diagram-text flex-grow lg:flex-grow-0">
			{{text}}
		</div>
	</div>
</template>
<script>
export default {
	name: 'patient-diagram-step',
	props: {
		textBgColor: String,
		textColor: {
			type: String,
			default: '#fff'
		},
		iconColor: String,
		text: String
	},
	computed: {
		cssVariables() {
			return {
				'--text-bg-color': this.textBgColor,
				'--text-color': this.textColor,
				'--icon-color': this.iconColor
			}
		}
	}
}
</script>

<style lang="postcss" scoped>
	.diagram-step-wrapper {
		width: 100%;
		height: 75px;
		display: flex;
		justify-content: space-between;
		z-index: 1;
	}
	.diagram-icon {
		display: flex;
		align-items: center;
	}
	.diagram-icon-wrapper {
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--icon-color);
	}
	.diagram-line {
		min-width: 75px;
		margin-left: -18px;
		border-bottom: 2px solid theme('colors.black-blue');
		z-index: 10;
	}
	.diagram-text {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem;
		color: var(--text-color);
		background-color: var(--text-bg-color);
	}
	@media screen and (min-width: 1024px) {
		.diagram-step-wrapper {
			width: auto;
			height: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.diagram-icon {
			height: 75px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.diagram-icon-wrapper {
			width: 50px;
			height: auto;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 10;
		}
		.diagram-line {
			min-width: 0;
			height: 100%;
			margin-left: 0;
			border-left: 2px solid theme('colors.black-blue');
			border-bottom: 0;
		}
		.diagram-text {
			display: flex;
			width: 150px;
			justify-content: center;
			align-items: center;
			padding: 0.5rem 0;
		}
	}
</style>